export default "__VITE_ASSET__e82c5d5b__"